import { MuiOtpInput } from 'mui-one-time-password-input'
import type { SxProps, Theme } from '@mui/material'
import { PIN_DIGITS, sanitizeDigitInput } from '../../util/securityCredentials'

/** Digit cells that share the dialog width, so the row meets the right edge. */
const pinDigitInputSx: SxProps<Theme> = {
	width: '100%',
	display: 'flex',
	gap: '8px',
	'& .MuiOtpInput-TextField': {
		flex: '1 1 0',
		minWidth: 0,
	},
	'& .MuiOutlinedInput-root': {
		height: 40,
		borderRadius: '4px',
		'& fieldset': { borderRadius: '4px' },
		'&.Mui-focused fieldset': { borderWidth: '1px' },
	},
	'& .MuiInputBase-input': {
		fontSize: '1.15rem',
		padding: '0 !important',
		textAlign: 'center',
	},
}

type Props = {
	value: string
	onChange: (value: string) => void
	onComplete?: (value: string) => void
	autoFocus?: boolean
	disabled?: boolean
	/** PIN is 4. Email OTP is 6. */
	length?: number
	/** Hide characters. OTP stays visible. */
	masked?: boolean
	/** Override when the surrounding screen already has a PIN input style (login). */
	sx?: SxProps<Theme>
}

const PinDigitInput = ({
	value,
	onChange,
	onComplete,
	autoFocus,
	disabled,
	length = PIN_DIGITS,
	masked = true,
	sx,
}: Props) => {
	return (
		<MuiOtpInput
			value={value}
			length={length}
			autoFocus={autoFocus}
			validateChar={(c) => /^\d$/.test(c)}
			onChange={(next) => onChange(sanitizeDigitInput(next, length))}
			onComplete={
				onComplete
					? (next) => {
							// The OTP input refocuses the last box after onComplete.
							setTimeout(() => onComplete(next), 0)
						}
					: undefined
			}
			TextFieldsProps={{
				type: masked ? 'password' : 'text',
				autoComplete: 'off',
				disabled,
				inputProps: { inputMode: 'numeric' },
			}}
			sx={sx ?? pinDigitInputSx}
		/>
	)
}

export default PinDigitInput
